import { connect } from 'react-redux';

import AuthoriserSelector from '../../../sharedComponents/AuthoriserSelector/AuthoriserSelector';
import { setIFTPaymentAuthorisers } from '../../../states/ift/actions';
import { getIFTSingleAuthorisersList, getIFTMultiAuthorisersList } from '../../../states/ift/selectors';
import { getUserId } from '../../../states/user/selectors';

const mapState = (state, props) => ({
	singleAuthorisersList: getIFTSingleAuthorisersList(state, props.paymentId),
	multiAuthorisersList: getIFTMultiAuthorisersList(state, props.paymentId),
	userId: getUserId(state),
});

const mapDispatch = (dispatch) => ({
	onConfirm: (authorisers, paymentId) => dispatch(setIFTPaymentAuthorisers(authorisers, paymentId)),
});

export default connect(mapState, mapDispatch)(AuthoriserSelector);
